// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorLabel_error__9hMaF"};